import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { LeadsPage } from './pages/LeadsPage';
import { UsersPage } from './pages/UsersPage';
import { PrinterModelsPage } from './pages/PrinterModelsPage';
import { BrandSettingsPage } from './pages/BrandSettingsPage';
import { SettingsPage } from './pages/SettingsPage';
import { BlogPage } from './pages/BlogPage';
import { ContactMessagesPage } from './pages/ContactMessagesPage';
import { KnowledgeBasePage } from './pages/KnowledgeBasePage';
import { ProductsPage } from './pages/ProductsPage';
import { CompaniesPage } from './pages/CompaniesPage';
import { PartnerLeadsPage } from './pages/PartnerLeadsPage';
import { PartnerAccountPage } from './pages/PartnerAccountPage';
import { SetPasswordPage } from './pages/SetPasswordPage';
import { useAuth } from './hooks/useAuth';
import type { Vertical } from './types';

function App() {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/set-password" element={<SetPasswordPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  // Partner users only get access to their leads — no settings or admin pages
  if (user?.role === 'partner') {
    return (
      <Layout>
        <Routes>
          <Route path="/leads" element={<PartnerLeadsPage />} />
          <Route path="/account" element={<PartnerAccountPage />} />
          <Route path="*" element={<Navigate to="/leads" replace />} />
        </Routes>
      </Layout>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/leads" element={<LeadsPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/companies" element={<CompaniesPage />} />
        <Route path="/printer-settings" element={<PrinterModelsPage defaultVertical={'copiers' as Vertical} />} />
        <Route path="/printer-models" element={<Navigate to="/printer-settings" replace />} />
        <Route path="/print/settings" element={<Navigate to="/printer-settings" replace />} />
        <Route path="/brands/:brandId" element={<BrandSettingsPage />} />
        <Route path="/brand-settings" element={<BrandSettingsPage />} />
        <Route path="/contact-messages" element={<ContactMessagesPage />} />
        <Route path="/knowledge-base" element={<KnowledgeBasePage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default App;
